// El backend solo entrega eventos de una cuenta al socket autenticado como esa
// cuenta (server/index.js). Sin token el socket conecta pero no recibe nada.
export function withWsToken(url) {
  let token = null;
  try { token = localStorage.getItem('authToken'); } catch (e) { token = null; }
  if (!token) return url;
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}token=${encodeURIComponent(token)}`;
}
